import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b048d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shop-bottom text-rt"
}
const _hoisted_2 = {
  key: 0,
  class: "fee"
}
const _hoisted_3 = { class: "fee" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "jpy" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "fee"
}
const _hoisted_8 = { class: "color-555" }
const _hoisted_9 = { class: "red-color" }
const _hoisted_10 = { class: "jpy" }
const _hoisted_11 = {
  key: 2,
  class: "fee"
}
const _hoisted_12 = { class: "color-555" }
const _hoisted_13 = { class: "color-555 price2" }
const _hoisted_14 = {
  key: 3,
  class: "fee"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-question cursor-pt" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ： ")
const _hoisted_18 = { class: "price" }
const _hoisted_19 = { class: "fee" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("： ")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "jpy" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "fee" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "rr-color" }
const _hoisted_28 = { class: "ml_10 small jpy" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "small gray flex-end" }
const _hoisted_31 = { class: "tip" }
const _hoisted_32 = {
  style: {"margin-top":"16px"},
  class: "fee"
}
const _hoisted_33 = {
  key: 1,
  class: "shop-bottom text-rt"
}
const _hoisted_34 = { class: "fee" }
const _hoisted_35 = { class: "fee" }
const _hoisted_36 = { class: "rr-color" }
const _hoisted_37 = { class: "ml_10 small jpy" }
const _hoisted_38 = { class: "small gray flex-end" }
const _hoisted_39 = { class: "tip" }
const _hoisted_40 = {
  style: {"margin-top":"16px"},
  class: "fee"
}
const _hoisted_41 = {
  key: 0,
  class: "flex-ter expo-code"
}
const _hoisted_42 = { class: "expo-title" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expo-line1" }, " FaW Tokyo展示会 ", -1))
const _hoisted_44 = { class: "expo-line2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "専用クーポン:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "任意", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"204px","font-size":"14px","padding":"6px"} }, " ※クーポンコードをお持ちの方はご入力ください。 ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/question_icon.png?v=2",
  alt: "",
  style: {"margin":"2px 0 0 4px"}
}, null, -1))
const _hoisted_49 = {
  style: {"position":"sticky","bottom":"0","background":"#fff","z-index":"1000"},
  class: "figure-pay-content"
}
const _hoisted_50 = {
  key: 0,
  class: "FreeShipping"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/SEO/activity_shopcart_coupon.png",
  alt: ""
}, null, -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coupon" }, "国際送料が無料になります", -1))
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" ご注文金額は、")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coupon" }, "送料無料特典", -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode("の条件を満たしています ")
const _hoisted_58 = [
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createTextVNode("。 ")
const _hoisted_60 = { key: 2 }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" あと ")
const _hoisted_62 = { class: "coupon" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("元で特典が適用されます。")
const _hoisted_64 = {
  key: 1,
  class: "cashback"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/activity/cashback_welcome_icon.png",
  alt: ""
}, null, -1))
const _hoisted_66 = { class: "total" }
const _hoisted_67 = ["href"]
const _hoisted_68 = {
  key: 0,
  style: {"flex":"1"},
  class: "agree-btn"
}
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = { class: "mr_20 total-sticky-content" }
const _hoisted_71 = { class: "order-num" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-rt flex-end-ter" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "rr-color" }, "0")
], -1))
const _hoisted_73 = {
  key: 0,
  class: "order-num"
}
const _hoisted_74 = {
  class: "text-rt flex-end",
  style: {"align-items":"baseline"}
}
const _hoisted_75 = { class: "rr-color" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "-円", -1))
const _hoisted_77 = {
  key: 0,
  class: "order-num"
}
const _hoisted_78 = {
  class: "text-rt flex-end",
  style: {"align-items":"baseline"}
}
const _hoisted_79 = { class: "rr-color" }
const _hoisted_80 = { class: "small" }
const _hoisted_81 = { class: "order-num" }
const _hoisted_82 = { class: "text-rt flex-end-ter" }
const _hoisted_83 = { class: "rr-color" }
const _hoisted_84 = { class: "small" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  key: 1,
  class: "flex-ter float"
}
const _hoisted_88 = ["disabled"]

import { ref, computed, watch, nextTick, onMounted } from 'vue'
import { t as _t } from '@/plugins/i18n'
import WatchSticky from '@/components/common/WatchSticky.vue'
import { formatMoney } from '@/plugins/utils'
import { getWallet } from '@/apis/user'
import { defectiveProductRiskFlag, updateProductRisk } from '@/apis/shopcart'
import { getUser, getEffectTermByType, agreeTerm } from '@/apis/login'
import { calc, formatMoneyDirection } from '@/util/useYan'
import { useStore } from 'vuex'
import OpenMember from './OpenMember.vue'
import ExceedingNumTip from './ExceedingNumTip.vue'
import { isD2C, useSite2Station, isKO, isJA, isEN } from '@/store'
import TermModal from '@/components/termModal/index.vue'
import { Term } from '@/common/const'
import dayjs from 'dayjs'
import { getTrueNumber } from '@/util/common'
import { tCurrency, sourceCountryRef } from '../country'
import { COUNTRY } from '@/global'
import MemberEventBox from '@/components/common/MemberEventBox.vue'
import bus from '@/util/useBus'
import { QuestionFilled } from '@element-plus/icons-vue'
import { request } from '@/config/request/interceptors'
import { CashbackActivityRespDTO, CustomerActivityRespDTO } from '@/service/market'

export default /*#__PURE__*/_defineComponent({
  props: [
  'confirm',
  'pdtFee',
  'adtFee',
  'curPdtFee',
  'disabled',
  'isNumberExceed',
  'mode',
  'hiddenGroupBtn',
  'emitSubmit',
  'errorGoods',
  'totalBuyQuantity',
  'combineAdditionTotalFee',
  'showNum',
  // choice一价全包商品价格
  'choiceTotalAmount',
  // 是否为choice商品结算
  'isChoice',
  'loading',
  'cartGoodsMode',
  'showInviteCode',
  'isExtStock'
],
  emits: ['commit', 'createGroup', 'getWallet', 'submit'],
  setup(__props, { expose, emit }) {

const props = __props
const coupon = ref<CustomerActivityRespDTO>()
const cashback = ref<CashbackActivityRespDTO>()
onMounted(async () => {
  if (isJA()) {
    const res = await request.market.activitySceneConfig.customerQuery({})
    const res1 = await request.market.cashback.customerQuery({})
    coupon.value = res.data
    cashback.value = res1.data
  }
})

const showFreeShipping = computed(() => {
  return isJA() && coupon.value?.couponInfo?.usedStatus === 0 && sourceCountryRef.value === COUNTRY.CN && props.cartGoodsMode === 1 && coupon.value.couponInfo.couponType === 3 && !coupon.value.couponInfo.startDate
})

const needCashback = computed(() => {
  const needMoney = +(cashback.value?.activityInfo?.thresValue ?? 0) - +(cashback.value?.totalOrderAmount ?? 0)
  return needMoney > 0 ? needMoney.toFixed(2) : 0
})

const showCashback = computed(() => {
  return needCashback.value && cashback.value?.totalOrderAmount
})

const needFreeShipping = computed(() => {
  try {
    if (showFreeShipping.value) {
      return (coupon.value?.activityInfo?.thresValue - rmb.value > 0) ? (coupon.value?.activityInfo?.thresValue - (rmb.value ?? 0)).toFixed(2) : 0
    } else {
      return null
    }
  } catch (error) {
    return null
  }
})

const handleConfirm = () => {
  location.href = `/sub/activity?id=${coupon.value?.couponInfo?.id}`
}

// 先转换货币
const t = (str: string) => {
  const ccy = tCurrency(str)
  return ccy ?? _t(str)
}
// 展会码
const inviteCode = ref('')
const stationCode = useSite2Station()
const store = useStore()
// emitSubmit 是否点击支付抛出
// hiddenGroupBtn 是否隐藏组合按钮
// pdtFee 商品预估价格
// adtFee 商品预估附加项价格
// curPdtFee /** 本期支付总金额 */
// curPdRate /** 本期支付总金额比例 */
// falPdRmb /** 尾款支付总金额 */
// falPdRate /** 尾款支付总金额比例 */
// errorGoods 异常商品
// totalBuyQuantity 下单商品总数量
// showNum是否展示勾选商品数量


const pdtRmb = computed(() => formatMoney(props.pdtFee))
const pdtJpy = computed(() => calc(props.pdtFee))
const adtRmb = computed(() => formatMoney(props.adtFee))
const curPdtRmb = computed(() => formatMoney(props.curPdtFee))
const curPdRate = computed(() =>
  (
    (props.curPdtFee / props.pdtFee ? props.curPdtFee / props.pdtFee : 0) * 100
  ).toFixed(2)
)
const falPdRmb = computed(() => formatMoney(props.pdtFee - props.curPdtFee))
const falPdRate = computed(() =>
  (props.curPdtFee / props.pdtFee
    ? 100 - (props.curPdtFee / props.pdtFee) * 100
    : 0
  ).toFixed(2)
)

const rmb = computed(() => {
  let price = ''
  if (props.confirm && props.mode === 0) {
    price = formatMoney(props.curPdtFee + props.adtFee)
  } else {
    price = formatMoney(props.pdtFee + props.adtFee)
  }
  return price
})
//

const yan = computed(() => {
  let price: any = ''
  if (props.confirm && props.mode === 0) {
    price = calc(props.curPdtFee + props.adtFee, sourceCountryRef.value === COUNTRY.KR ? 'KRW' : 'CNY')
  } else {
    price = calc(props.pdtFee + props.adtFee, sourceCountryRef.value === COUNTRY.KR ? 'KRW' : 'CNY')
  }
  return price
})

const rest = ref('')
const restJPY = ref('')
const token = store.getters.token

// 是否禁止提交
const disabledBtn = computed(() => {
  return Object.keys(props.errorGoods ?? [])?.length > 0
})

const getWalletInfo = () => {
  getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: sourceCountryRef.value === COUNTRY.KR ? 'KRW' : 'CNY'
  }).then((res) => {
    if (res.success) {
      rest.value = formatMoney(res.data.availableAmount)
      restJPY.value = calc(res.data.availableAmount, sourceCountryRef.value === COUNTRY.KR ? 'KRW' : 'CNY')
    }
  })
}
watch(() => sourceCountryRef.value, () => {
  getWalletInfo()
}, {
  immediate: true
})
watch(
  () => props.isNumberExceed,
  (value: any) => {
    isAgree.value = true
  }
)

watch(
  () => props.mode,
  () => {
    if (!props.mode) isAgree.value = true
  }
)

const isSticky = ref(true)
const isAgree = ref(false)

const argeeVisiable = ref(false) // 是否显示不良品风险提示
const openMemberRef = ref()
const exceedingNumTip = ref()
const termModalRef = ref()
const term = ref()
const catTerm = async () => {
  //
  const res = await getEffectTermByType({
    stationCode,
    type: Term.regular
  })
  term.value = res.data[0]

  // 等待props更新后，在open
  nextTick(termModalRef.value.open)
}
// 提交订单
const submitOrder = () => {
  if (props.disabled || (!isAgree.value && props.isNumberExceed)) return
  getUser(token).then((res: any) => {
    if (res.code === '0') {
      if (props.emitSubmit) {
        emit('submit')
        return
      }
      // 接受不良风险提示
      defectiveProductRiskFlag().then((response: any) => {
        if (response.code === '0') {
          if (!response.data) {
            catTerm()
            return
            // argeeVisiable.value = true;
            // riskArgeement.value.sendCode(); // 倒计时 5s
          }
          // 判断是否是经济舱会员并且下单数量超过200件，并且是采购到库存的订单，引导用户开通标准舱会员
          if (
            res.data.membership.templateLevel === 1 &&
            props.totalBuyQuantity >= 200 &&
            props.mode === 0 &&
            !isEN()
          ) {
            exceedingNumTip.value.open()
            return
          }
          emit('commit')
        }
      })
    }
  })
}

// 接受不良风险提示
const acceptArgeement = async () => {
  const textData = termModalRef.value.fetchText(term.value.fileUrl)

  const adverRisk = `
    ご注文の際に検品オプションを選択頂いた場合、当社の検品標準により検品を行います。
    不良品と判断される場合、ご指定頂いた不良品の対応方式に従って「返品返金」OR 「交換」を行います。
    但し、当社で不良品と判断されたものの、販売サイトまたはショップに対して返品できないため返品不可になる場合がありますので予めご了承下さい。
    （発生確率が約0~0.1%程度）

    その場合、当該不良品が返品不可不良品となります。

    返品不可不良品に対して、【在庫管理】メニュー で廃棄処理を依頼するか、
    お客様の許可を得た上で、良品としてお客様に配送するか、
    いずれかの処理方法を選択することができます。

    当社で廃棄処理を依頼する場合、お客様において当該商品の所有権が放棄されたものとみなし、ショップから商品代金の返金はなされませんので予めご了承ください。

    ※以下のいずれかに該当する場合は返品不可不良品となる可能性があります。
    ・お客様の検品要求が常に厳しく、ショップ側が不良品と認められない場合
    ・ショップ側は7日間無条件返品サービスを提供してない場合
    ・お客様都合により返品受付期間内（商品到着後7日以内）に返品要求を提出してない場合※返品不可不良品の発生を回避する方法については、下記の内容をご参照下さい。
      ${isD2C()
      ? 'https://s.theckb.com/d2c/article/2/78'
      : 'https://s.theckb.com/b2b/article/2/78'
    }
    `

  try {
    await agreeTerm({
      termId: term.value.termId
    })

    const res = await updateProductRisk({
      confirmationStyle: 1, // 1： 下单  2：API订单  3：邮箱
      version: '1.0' + '-' + textData.data
    })

    if (res.code === 0) {
    }
  } catch (error) { }

  updateProductRisk({
    confirmationStyle: 1, // 1： 下单  2：API订单  3：邮箱
    version: '1.0' + '-' + textData.data
  }).then((res: any) => {
    if (res.code === '0') {
      argeeVisiable.value = false
      onagree()
      getUser(token).then((res: any) => {
        // 判断是否是经济舱会员并且下单数量超过200件，并且是采购到库存的订单，引导用户开通标准舱会员
        if (
          res.data.membership.templateLevel === 1 &&
          props.totalBuyQuantity >= 200 &&
          props.mode === 0
        ) {
          exceedingNumTip.value.open()
          return
        }
        emit('commit')
      })
    }
  })
}

const onagree = () => {
  termModalRef.value.close()
}
const pay = () => {
  if (disabledBtn.value) return
  emit('commit')
}
expose({
  getWalletInfo,
  inviteCode
})
bus.on('shopPaySuccess', () => {
  getWalletInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle([{"text-align":"right"}, { minHeight: __props.cartGoodsMode === 0 ? '500px' : '' }])
    }, [
      (__props.cartGoodsMode !== 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!__props.isChoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (__props.showNum)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("span", null, _toDisplayString(t('订单商品总数量')) + "：", 1),
                        _createElementVNode("span", null, _toDisplayString(__props.totalBuyQuantity) + " " + _toDisplayString(t('件')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(t('订单商品代金(预估)')) + "：", 1),
                    (!__props.isExtStock)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createTextVNode(_toDisplayString(_unref(pdtRmb)) + " " + _toDisplayString(t('元')) + " ", 1),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatMoneyDirection)(_unref(calc)(__props.pdtFee, _unref(sourceCountryRef) === _unref(COUNTRY).KR ? 'KRW' : 'CNY'))), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                  ]),
                  (__props.confirm && __props.mode === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(`${t('本次实付商品代金')}(${_unref(curPdRate)}%)`) + "： ", 1)
                        ]),
                        _createElementVNode("span", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_unref(curPdtRmb)) + " " + _toDisplayString(t('元')) + " ", 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatMoneyDirection)(_unref(calc)(__props.curPdtFee, _unref(sourceCountryRef) === _unref(COUNTRY).KR ? 'KRW' : 'CNY'))), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.confirm && __props.mode === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(`${t('待支付商品代金尾款')}(${_unref(falPdRate)}%)`) + "：", 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(falPdRmb)) + " " + _toDisplayString(t('元')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.combineAdditionTotalFee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(t('组合返工费用')) + " ", 1),
                          _createVNode(_component_el_tooltip, {
                            effect: "light",
                            placement: "top",
                            "popper-class": "tool-tip-no-border"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", {
                                style: {"max-width":"200px"},
                                innerHTML: t('成品区库存重组需收取组合费用')
                              }, null, 8, _hoisted_15)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }),
                          _hoisted_17
                        ]),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(getTrueNumber)(__props.combineAdditionTotalFee)) + " " + _toDisplayString(t('元')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(t('订单商品附加项(预估)')) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        "popper-class": "style-tip-icon-width",
                        effect: "light",
                        content: t('此商品附加项只对该订单中需采购的商品生效，对库存商品不生效')
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _hoisted_21
                    ]),
                    (!__props.isExtStock)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                          _createTextVNode(_toDisplayString(_unref(adtRmb)) + " " + _toDisplayString(t('元')) + " ", 1),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(formatMoneyDirection)(_unref(calc)(__props.adtFee, _unref(sourceCountryRef) === _unref(COUNTRY).KR ? 'KRW' : 'CNY'))), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, _toDisplayString(t('订单本次实付金额(预估)')) + "： ", 1),
                    (!__props.isExtStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(rmb)) + " " + _toDisplayString(t('元')), 1),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatMoneyDirection)(_unref(yan))), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(t(
                '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。'
              )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(t('当前余额')) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(rest.value) + " " + _toDisplayString(t('元')), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", null, _toDisplayString(t('订单商品总数量')) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount?.totalQuantity)) + " " + _toDisplayString(t('件')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", null, _toDisplayString(t('订单金额')) + "： ", 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount?.totalPriceJPY)) + "円", 1),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount?.totalPriceCNY)) + " " + _toDisplayString(t('元')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(t(
                '提示：一口价商品，单价固定，下单时一次性扣除所有费用，实际费用将在商品上架时按最终上架数量进行收取，多退少补。'
              )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", null, _toDisplayString(t('当前余额')) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(rest.value) + " " + _toDisplayString(t('元')), 1)
                  ]),
                  (__props.showInviteCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _hoisted_46,
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              placement: "top",
                              "popper-class": "tool-tip-no-border"
                            }, {
                              content: _withCtx(() => [
                                _hoisted_47
                              ]),
                              default: _withCtx(() => [
                                _hoisted_48
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_el_input, {
                          class: "expo-input",
                          placeholder: t('请填写展会优惠码'),
                          modelValue: inviteCode.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inviteCode).value = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ], 4),
    (!__props.confirm)
      ? (_openBlock(), _createBlock(WatchSticky, {
          key: 0,
          modelValue: isSticky.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isSticky).value = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              (_unref(showFreeShipping))
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    (_unref(needFreeShipping) != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                          _createTextVNode(" ご注文金額が" + _toDisplayString(coupon.value?.activityInfo?.thresValue) + "元を超えると、 ", 1),
                          _hoisted_53
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_58)),
                    _createVNode(_component_el_popover, {
                      width: "300px",
                      style: {"padding":"10px"},
                      content: "※国際送料は、出荷時の梱包内容に基づいて自動で計算・割引が適用されます。",
                      placement: "bottom"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_59,
                    (_unref(needFreeShipping) != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(needFreeShipping)), 1),
                          _hoisted_63
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" ※有効期限：" + _toDisplayString(_unref(dayjs)(coupon.value?.couponInfo?.effectEndTime).format('YYYY/MM/DD')) + "まで ", 1),
                    _createElementVNode("span", {
                      class: "sesDetail",
                      onClick: handleConfirm
                    }, _toDisplayString('特典詳細を見る >'))
                  ]))
                : (!_unref(showFreeShipping) && cashback.value?.activityInfo?.id && _unref(needCashback) && !__props.isChoice && _unref(rmb) != '0')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _hoisted_65,
                      _createElementVNode("span", null, [
                        _createTextVNode(" あと " + _toDisplayString(_unref(needCashback)) + "元で " + _toDisplayString(cashback.value.activityInfo.cashbackRate) + "％還元！ 現在の累計注文金額：", 1),
                        _createElementVNode("span", _hoisted_66, _toDisplayString(cashback.value.totalOrderAmount) + "元", 1),
                        _createTextVNode("／目標：" + _toDisplayString(cashback.value.activityInfo.thresValue) + "元 ", 1)
                      ]),
                      _createElementVNode("a", {
                        class: "activity",
                        href: `/hub/cashback?id=${cashback.value?.activityInfo?.id}`,
                        target: "_blank"
                      }, " 詳細を見る>", 8, _hoisted_67)
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-ter float", { sticky: isSticky.value, numberExceedPadding: __props.isNumberExceed }])
              }, [
                (__props.isNumberExceed && __props.mode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: isAgree.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAgree).value = $event)),
                        style: {"font-size":"12px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: t('同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货'),
                            style: {"line-height":"16px","color":"#7E8694"}
                          }, null, 8, _hoisted_69)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, { name: "el-fade-in" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_70, [
                      (__props.cartGoodsMode === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_71, _toDisplayString(t('订单金额')) + "：", 1),
                            _hoisted_72
                          ], 64))
                        : (__props.isExtStock)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!__props.isChoice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createTextVNode(_toDisplayString(t('订单商品总数量')) + "：" + _toDisplayString(__props.totalBuyQuantity) + _toDisplayString(t('件')) + ",", 1),
                                    _createElementVNode("span", null, _toDisplayString(t('订单预估总价')) + ":", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("span", _hoisted_75, "-" + _toDisplayString(t('元')), 1),
                                _hoisted_76
                              ])
                            ], 64))
                          : (!__props.isChoice)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (!__props.isChoice)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                      _createTextVNode(_toDisplayString(t('订单商品总数量')) + "：" + _toDisplayString(__props.totalBuyQuantity) + _toDisplayString(t('件')) + ",", 1),
                                      _createElementVNode("span", null, _toDisplayString(t('订单预估总价')) + ":", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(_unref(rmb)) + _toDisplayString(t('元')), 1),
                                  _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(formatMoneyDirection)(_unref(yan),)), 1)
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("div", _hoisted_81, _toDisplayString(t('订单金额')) + "：", 1),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount.totalPriceJPY)) + "円", 1),
                                  _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(formatMoney)(__props.choiceTotalAmount.totalPriceCNY)) + _toDisplayString(t('元')), 1)
                                ])
                              ], 64))
                    ], 512), [
                      [_vShow, isSticky.value]
                    ])
                  ]),
                  _: 1
                }),
                (!__props.isChoice && __props.cartGoodsMode !== 0)
                  ? (_openBlock(), _createBlock(MemberEventBox, {
                      key: 1,
                      style: {"margin-right":"20px"}
                    }, {
                      default: _withCtx(() => [
                        (!__props.hiddenGroupBtn && _unref(isJA)() && !__props.isChoice)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "group-btn",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('createGroup')))
                            }, _toDisplayString(t('创建组合商品')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!__props.isChoice)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      type: "primary",
                      class: "dark submit-btn",
                      onClick: submitOrder,
                      disabled: __props.disabled || (!isAgree.value && __props.isNumberExceed),
                      style: _normalizeStyle({ cursor: __props.disabled || (!isAgree.value && __props.isNumberExceed) ? 'no-drop' : 'pointer' })
                    }, [
                      _createVNode(_component_el_popover, {
                        disabled: !(_unref(needFreeShipping) === 0 && _unref(showFreeShipping)),
                        visible: _unref(needFreeShipping) === 0 && _unref(showFreeShipping),
                        teleported: false,
                        "popper-class": "couponPopper",
                        width: 103,
                        placement: "top"
                      }, {
                        reference: _withCtx(() => [
                          _createTextVNode(_toDisplayString(t('提交订单')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(coupon.value?.couponInfo?.feeToCut) + "kg分 送料無料 ", 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "visible"])
                    ], 12, _hoisted_85))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      type: "primary",
                      class: "dark submit-btn",
                      onClick: submitOrder,
                      disabled: __props.disabled,
                      style: { cursor: 'pointer' }
                    }, _toDisplayString(t('提交订单')), 9, _hoisted_86))
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_87, [
          (!__props.isChoice)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                type: "primary",
                class: "submit-btn",
                onClick: pay,
                disabled: _unref(disabledBtn)
              }, _toDisplayString(t('确认并支付')), 9, _hoisted_88))
            : _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                type: "primary",
                class: "submit-btn cursor-pt",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('commit')))
              }, [
                _createTextVNode(_toDisplayString(t('确认并支付')), 1)
              ], 512)), [
                [_directive_loading, __props.loading]
              ])
        ])),
    _createVNode(OpenMember, {
      ref: (_value, _refs) => {
        _refs['openMemberRef'] = _value
        openMemberRef.value = _value
      }
    }, null, 512),
    _createVNode(ExceedingNumTip, {
      ref: (_value, _refs) => {
        _refs['exceedingNumTip'] = _value
        exceedingNumTip.value = _value
      },
      totalBuyQuantity: __props.totalBuyQuantity,
      onCloseExceeding: _cache[5] || (_cache[5] = ($event: any) => (emit('commit')))
    }, null, 8, ["totalBuyQuantity"]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModalRef'] = _value
        termModalRef.value = _value
      },
      title: t('次转正提醒'),
      fileUrl: term.value?.fileUrl,
      disableBtn: true,
      timer: true,
      onagree: onagree,
      "ondis-agree": acceptArgeement
    }, null, 8, ["title", "fileUrl"])
  ], 64))
}
}

})